import { TenantDetails } from "@/store/authStore";
import { AppEnvironment, getAppEnvironment } from "@/lib/utils";

export interface ThemeColours {
    light: { primary: string, secondary: string };
}

export enum LogoType {
    LightPrimary,
    LightMini,
    DarkPrimary,
    DarkMini,
}

// export interface Logos {
//     LightPrimary: string;
//     LightMini: string;
//     DarkPrimary: string;
//     DarkMini: string;
// }

export interface Logos {
    [LogoType.LightPrimary]: string;
    [LogoType.LightMini]: string;
    [LogoType.DarkPrimary]: string;
    [LogoType.DarkMini]: string;
}

export interface Theme {
    colours: ThemeColours;
    logos: Logos;
    tenant: TenantDetails;
}

// Construct the full theme path URL if it's not already a full URL
const getFullThemePath = (themePath: string): string => {
    // If already a full URL, use as-is
    if (themePath.startsWith('http://') || themePath.startsWith('https://')) {
        return themePath;
    }
 
    // Determine bucket based on environment
    const bucket = getAppEnvironment() === AppEnvironment.Production ? 'watchful-public' : 'crosbies-public';
    return `https://storage.googleapis.com/${bucket}/theme/${themePath}`;
};

export const logoUrls = (tenant: TenantDetails) => {
    const themePath = getFullThemePath(tenant.themePath);
    return {
        [LogoType.LightPrimary]: `${themePath}/logo.png?v=${tenant.themeVersion}`,
        [LogoType.LightMini]: `${themePath}/logo_mini.png?v=${tenant.themeVersion}`,
        [LogoType.DarkPrimary]: `${themePath}/logo_reverse.png?v=${tenant.themeVersion}`,
        [LogoType.DarkMini]: `${themePath}/logo_mini_reverse.png?v=${tenant.themeVersion}`,
    };
};

export async function lookupTheme(tenant: TenantDetails): Promise<Theme> {
    const themePath = getFullThemePath(tenant.themePath);
    const themeJson = `${themePath}/theme.json?v=${tenant.themeVersion}`;
    const response = await fetch(themeJson);
    const theme = await response.json() as ThemeColours;

    return {
        colours: theme,
        logos: logoUrls(tenant),
        tenant,
    }
  
}